import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProtectedView from 'containers/ProtectedView';
import { PORTAL_ACCESS_ROLES } from 'utils/constants/roles';
import { PAGE_URLS, ROLES } from 'utils/constants';
import { getUserRoles } from 'reducers/users';
import { getSecurityCompanyBillingInfo } from 'reducers/securityCompany/index';
import { AccountPage } from 'containers/Pages/Admin/Account';
import isEmpty from 'lodash/isEmpty';

import LinearProgress from '@material-ui/core/LinearProgress';

const ProtectedRoute = ({
  component: Component,
  authenticated,
  roles,
  billingInfo,
  loading,
}) => {
  const pathKey = Object.keys(PAGE_URLS).find(
    key => PAGE_URLS[key].link === window.location.pathname,
  );
  const isAccountHolder =
    roles && roles.includes(ROLES.SECURITY_COMPANY_MANAGER.id);

  const hasCardDetails = isEmpty(billingInfo)
    ? false
    : Boolean(billingInfo.paymentMethod.last4);

  const renderAccountPage = () => {
    if (loading) {
      return <LinearProgress />;
    }

    return <AccountPage />;
  };
  // only redirect to login page when we know we are not authenticated (false) otherwise authenticated is undefined
  /* eslint-disable consistent-return */
  const redirectToLogin = props => {
    if (typeof authenticated === 'boolean' && authenticated === false) {
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      );
    }
  };

  return (
    <Route
      render={props => {
        return authenticated ? (
          (isAccountHolder && hasCardDetails) || !isAccountHolder ? ( // you can only access the routes if you are an account holder and entered card details or you are not a account holder
            <ProtectedView
              allowedRoles={PORTAL_ACCESS_ROLES}
              path={PAGE_URLS[pathKey]}
              alwaysVisible={PAGE_URLS[pathKey]?.alwaysVisible}
            >
              <Component {...props} />
            </ProtectedView>
          ) : (
            renderAccountPage()
          )
        ) : (
          redirectToLogin(props)
        );
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  billingInfo: PropTypes.object,
  location: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  roles: PropTypes.array,
};

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
  roles: getUserRoles(state),
  billingInfo: getSecurityCompanyBillingInfo(state),
  loading: state.ui.loading,
});

export default connect(mapStateToProps)(ProtectedRoute);
